import { render, staticRenderFns } from "./PanelHome.vue?vue&type=template&id=08bb8f9c&scoped=true"
import script from "./PanelHome.vue?vue&type=script&lang=js"
export * from "./PanelHome.vue?vue&type=script&lang=js"
import style0 from "./PanelHome.vue?vue&type=style&index=0&id=08bb8f9c&prod&scoped=true&lang=css"
import style1 from "./PanelHome.vue?vue&type=style&index=1&id=08bb8f9c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08bb8f9c",
  null
  
)

export default component.exports